<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_account_contract"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="true"
        add-text="上传合同"
        @on-add="showFormModalDialog"
      />
      <ContractFormDialog
        :id="entityId"
        :visible="modalForm"
        :width="500"
        :action="url"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import ContractFormDialog from '../../partner/contract/contract-details'
export default {
  name: 'AccountContractList',
  components: { TableWrapper, ContractFormDialog },
  data() {
    return {
      url: this.$config.apiContextPath + '/account/contract',
      modalForm: false,
      entityId: 0,
      modCount: 0
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '车库', placeholder: '请输入车库...', name: 'parking', width: 'auto', type: 'input' },
          { label: '状态', placeholder: '请选择状态...', name: 'type', width: '100px', type: 'select', options: [
            { label: '已审核', value: 1 },
            { label: '待处理', value: 0 }
          ] }
        ]
      }
    },
    mockData() {
      return [
        {
          parking: '车库1', // 车库名
          status: '已审核', // 状态
          createTime: '2020-04-05 22:24', // 合同上传时间
          updateTime: '2020-04-25 23:01', // 更新时间
          operator: '张三' // 操作人员
        }
      ]
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '车库名', align: 'center', key: 'parkingName', sortable: true, ellipsis: true, tooltip: true },
        { title: '运营日期', align: 'center', key: 'parkingOnline', sortable: true, ellipsis: true, tooltip: true },
        { title: '车库容量', align: 'center', key: 'parkingCapacity', sortable: true, ellipsis: true, tooltip: true },
        { title: '合同备注', align: 'center', key: 'remarks', sortable: true, ellipsis: true, tooltip: true },
        { title: '创建时间', align: 'center', sortable: true, key: 'createTime', ellipsis: true, tooltip: true },
        { title: '更新时间', align: 'center', sortable: true, key: 'updateTime', ellipsis: true, tooltip: true },
        // { title: '状态', align: 'center', key: 'status', sortable: true, ellipsis: true, tooltip: true },
        // { title: '操作人员', align: 'center', sortable: true, key: 'operator', ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 220, key: '_actions', disabled: true,
          render: (h, params) => {
            const _this = this
            return h('div', [
              h('a', {
                domProps: {
                  href: _this.$config.storageHost + '/contract/' + params.row.contract,
                  target: '_blank'
                },
                style: { color: '#126D91', marginRight: '10px' }
              }, [
                h('i', { class: { 'fas': true, 'fa-cloud-download-alt': true, 'cell-icon-link': true }}),
                h('span', {}, '下载')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      // this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      // this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }
      ]
    },
    methods: {
      onModalClose(changed) {
        this.entityId = 0
        this.modalForm = false
        if (changed) {
          this.modCount = this.modCount + 1
        }
      },
      showFormModalDialog(id = '') {
        this.modalForm = true
        this.entityId = id ? parseInt(id) : 0
      }
    }
  }
}
</script>
